import Glide from '@glidejs/glide'
import { useState, useEffect } from 'react'
import { Controls } from '@glidejs/glide/dist/glide.modular.esm'
import { gsap } from "gsap";

const Carousel = ({element = 'portfolioSlider', images}) => {
  let szerE = screen.width;
  var szer = 1;
  var focus = 0;
  if (szerE<600){
    focus = szer = 0.5;
  }

    const [slider] = useState(new Glide(`.${element}`, {
      type: 'carousel',
      autoplay: 3000,
      animationDuration: 2000,
      animationTimingFunc: 'ease-in-out',
      focusAt: focus,
      arrows: true,
      perView: szer
    }))
    useEffect(() => {
       slider.mount({ Controls })
       gsap.fromTo(".infoBox", {opacity: 0, x:100}, {opacity: 1, delay:1,  x:0, duration: 0.8, ease: "power2"});
      // subscribe to an event 
      slider.on('run.before', (event) => {
        
        })
        
      // cleanup when unmounting component
      return () => slider.destroy()
    }, [])

   return (
       <div className={element}>
           
           <div className="glide__track z-[140] relative" data-glide-el="track">
                  <div className="glide__slides flex flex-nowrap w-screen h-screen">

                  { 
           
        images.map((item, index) => (
        
          <div class='glide__slide z-[140]'>            
            <div class="w-full h-full bg-cover bg-center portfolioSlider_pElement relative" style={{ backgroundImage: 'url('+item+')' }}></div>
          </div>
        ))
        }
                </div>
                <div class="glide__arrows text-black" data-glide-el="controls">
        <button class="absolute left-0 top-[50%] p-4 m-4 bg-primary rounded-full cursor-pointer" data-glide-dir="<">
        <ion-icon name="chevron-back-outline" class="w-6 h-6 align-middle text-black"></ion-icon>
        </button>
        <button class="absolute right-0 top-[50%] p-4 m-4 bg-primary rounded-full cursor-pointer" data-glide-dir=">">
        <ion-icon name="chevron-forward-outline" class="w-6 h-6 align-middle text-black" ></ion-icon>
        </button>
       </div>
           </div>
      
      </div>
  )
}
export default Carousel;
